import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef, Injector, LOCALE_ID, ChangeDetectorRef, Optional, Inject } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { ExpressionService, InjectedType, ExpressioneditorComponent } from '@gsp-svc/expression';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'app-title-expression',
  templateUrl: './title-expression.component.html',
  styleUrls: ['./title-expression.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class TitleExpressionComponent implements OnInit {

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input() value: any;
  textWithMultiLanguage: Map<string, string> = new Map<string, string>();

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;

  @Input() editorParams: any = {};
  language = 'zh-CHS';
  @ViewChild(ExpressioneditorComponent) editor: ExpressioneditorComponent;
  languageOptions = [
    { value: 'zh-CHS', text: this.localePipe.transform("component.titleExpression.zh-CHS") },
    { value: 'zh-CHT', text: this.localePipe.transform("component.titleExpression.zh-CHT") },
    { value: 'en', text: this.localePipe.transform("component.titleExpression.en") }
  ];
  contextEntities = [];

  schema: any = {};
  injectName = '';

  modalConfig = {
    title: this.localePipe.transform("component.titleExpression.taskDescription"),
    width: 1140,
    height: 720,
    showButtons: true
  };

  constructor(
    private expr: ExpressionService,
    private injector: Injector,
    public designerState: ProcessDesignerUIState,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    if (this.designerState.schemas[0]) {
      this.schema = this.designerState.schemas[0];
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        this.injectName = this.designerState.schemas[0].entityTypes[0].name;
      }
    }
    this.language = this.injector.get(LOCALE_ID, null) || this.language;
  }

  ngOnInit() {
    // 构造多语表达式编辑器的数据源，兼容历史
    if (this.value != null) {
      if (typeof(this.value) === 'string') {
        this.textWithMultiLanguage.set('zh-CHS', this.value);
      } else {
        this.textWithMultiLanguage = new Map(Object.entries(this.value));
      }
    }
    this.contextEntities = new Array();
    if (this.designerState.procInstContext.length > 0) {
      for (const variable of this.designerState.procInstContext) {
        this.contextEntities = this.contextEntities.concat([variable]);
      }
    }
    if (this.designerState.formalParameterContext.length > 0) {
      for (const variable of this.designerState.formalParameterContext) {
        if (!this.contextEntities.some(c => c.key === variable.key)) {
          this.contextEntities = this.contextEntities.concat([variable]);
        }
      }
    }
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!this.contextEntities.some(c => c.key === variable.key)) {
          this.contextEntities = this.contextEntities.concat([variable]);
        }
      }
    }
    if (this.designerState.participantContext.length > 0) {
      for (const variable of this.designerState.participantContext) {
        if (!this.contextEntities.some(c => c.key === variable.key)) {
          this.contextEntities = this.contextEntities.concat([variable]);
        }
      }
    }
    if (this.designerState.processVariableContext.length > 0) {
      for (const variable of this.designerState.processVariableContext) {
        if (!this.contextEntities.some(c => c.key === variable.key)) {
          this.contextEntities = this.contextEntities.concat([variable]);
        }
      }
    }
  }

  clickOK() {
    this.value = this.editor.getExprWithMultiLanguage();
    const obj = [...this.value.entries()].reduce((obj, [key, value]) => (obj[key] = value==null?'':value, obj), {});
    const object = { value: obj, parameters: null };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }

  private convertToValue(val: string): string {
    if (val) {
      if (val.substring(9, val.length - 2)) {
        return val;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

}
export class TitleExpressionConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data && typeof data === 'string') {
      return data;
    } else if (data && Object.keys(data).length > 0) {
      return this.areAllPropertiesEmpty(data)
        ? this.localePipe.transform("component.titleExpression.notSet")
        : this.localePipe.transform("component.titleExpression.set");
    } else {
      return this.localePipe.transform("component.titleExpression.notSet");
    }
  }

  areAllPropertiesEmpty(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }
  
}
